import { motion, useReducedMotion } from "framer-motion";
import clsx from "clsx";

const ICON_BG = {
  teal: "bg-teal-soft text-teal dark:bg-teal-2/15 dark:text-teal-3",
  gold: "bg-gold-soft text-amber-700 dark:bg-gold-2/15 dark:text-gold-2",
  pink: "bg-pink-100 text-pink-700 dark:bg-pink-500/15 dark:text-pink-300",
};

export default function FloatingCard({
  icon,
  tone = "teal",
  title,
  sub,
  className,
  delay = 0,
  floatDelay = 0,
}) {
  const reduce = useReducedMotion();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ delay, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={clsx("absolute z-20 hidden sm:block", className)}
    >
      <motion.div
        animate={reduce ? {} : { y: [0, -14, 0] }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: floatDelay,
        }}
        className="flex items-center gap-2.5 rounded-2xl border border-line bg-surface px-3.5 py-2.5 text-[12.5px] font-semibold shadow-card sm:px-4 sm:py-3"
      >
        <div
          className={clsx(
            "grid h-8 w-8 place-items-center rounded-xl text-[15px] sm:h-9 sm:w-9 sm:text-[17px]",
            ICON_BG[tone]
          )}
        >
          {icon}
        </div>
        <div className="leading-tight">
          <b className="block text-[12px] text-ink sm:text-[12.5px]">{title}</b>
          <small className="block text-[11px] font-normal text-ink-mute sm:text-[11.5px]">
            {sub}
          </small>
        </div>
      </motion.div>
    </motion.div>
  );
}